// @ts-nocheck
import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackSubmitReturnRequestParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/order/trackSubmitReturnRequest";

const useTrackSubmitReturnRequest = (
    parameters: TrackSubmitReturnRequestParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.submitReturnRequest, parameters, options);
};

export default useTrackSubmitReturnRequest;
